import {
     SET_ADMIN_DESIGNATION_ELEMENTS,
     ADD_ADMIN_DESIGNATION_ELEMENT,
     UPDATE_ADMIN_DESIGNATION_ELEMENT,
     DELETE_ADMIN_DESIGNATION_ELEMENT,
} from './actions';

// Initial State
const initialState = [];

const designationElementReducer = (state = initialState, action) => {
     switch (action.type) {
          case SET_ADMIN_DESIGNATION_ELEMENTS: {
               return action.payload;
          }

          case ADD_ADMIN_DESIGNATION_ELEMENT: {
               const newDesignationElements = [...state];

               // order is descending
               newDesignationElements.unshift(action.payload);

               return newDesignationElements;
          }

          case UPDATE_ADMIN_DESIGNATION_ELEMENT: {
               const designationElements = [...state];
               const newDesignationElements = [];

               for (let i = 0; i < designationElements.length; i++) {
                    const designationElement = designationElements[i];

                    if (designationElement.id === action.payload.id) {
                         newDesignationElements.push({ ...designationElement, ...action.payload });
                         continue;
                    }

                    newDesignationElements.push(designationElement);
               }

               return newDesignationElements;
          }

          case DELETE_ADMIN_DESIGNATION_ELEMENT: {
               const designationElements = [...state];

               return designationElements.filter((designationElement) => designationElement.id !== action.payload);
          }

          default:
               return state;
     }
};

// // Get designation element by id
export const getDesignationElementById = (state, designationElementId) => {
     return state.find((designationElement) => designationElement.id === designationElementId);
};

export default designationElementReducer;
